// @flow
import React from 'react'

// components
import { Bool } from '../../Components/_formFields'

// types
import type { DefaultMiniAppProps } from './'
import Popover from '../../Core/Components/Popover'

type CheckboxMiniAppProps = DefaultMiniAppProps & {
  miniAppData: {},
}

export default class CheckboxMiniApp extends React.Component<CheckboxMiniAppProps, null> {
  static defaultProps = {
    isBackOffice: false,
  }

  handleOnChange = (value: boolean, fieldKey: string) => {
    const { formData, onChangeFormData } = this.props
    const changedFormData = formData.set(fieldKey, value)
    onChangeFormData(changedFormData)
  }

  render() {
    const { content, formData, miniAppData, inputHelps, prefix } = this.props

    let fieldKey = ''
    let unCheckEnabled = true
    if (miniAppData && miniAppData.checkboxMiniApp && miniAppData.checkboxMiniApp[prefix]) {
      const settings = miniAppData.checkboxMiniApp[prefix]
      fieldKey = settings.fieldKey
      unCheckEnabled = !!settings.unCheckEnabled
    }

    if (!fieldKey) {
      return null
    }
    const actualValue = !!formData.getIn([fieldKey], false)
    return (
      <div
        className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-center"
        key="CheckboxMiniApp-content"
      >
        <div className="col-10 col-sm-3 order-0 order-sm-0 pt-sm-2 mt-sm-1 text-sm-right" />
        <div className="col-12 col-sm-6 order-3 order-sm-0 offset-sm-1 my-2">
          <Bool
            enabled={actualValue ? unCheckEnabled : true}
            id={fieldKey}
            isPristine
            label={content.fieldNames[fieldKey]}
            name={fieldKey}
            onChange={(value) => {
              this.handleOnChange(value, fieldKey)
            }}
            prefix=""
            validationErrors={{}}
            value={actualValue}
          />
        </div>
        <div className="col-2 col-sm-2 order-0 order-sm-0 text-right">
          {inputHelps && inputHelps.asMutable && inputHelps.getIn([prefix, 'content'], false) && (
            <Popover
              content={inputHelps.getIn([prefix, 'content'])}
              id={`checkboxMiniApp-${prefix}`}
              templateVariables={{}}
              title={inputHelps.getIn([prefix, 'title'])}
            />
          )}
        </div>
      </div>
    )
  }
}
